import React, { Component } from 'react'
import cx from 'classnames'
import { Div, Icon, H4 } from '@driftt/tide-core-legacy'
import './style.styl'

class NavAccordion extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: this.props.open,
    }
  }

  handleToggleAccordion = () => {
    this.setState({ open: !this.state.open })
  }

  render = () => {
    const { title, children } = this.props
    const { open } = this.state

    return (
      <Div className={cx('settings-main-navigation', { 'settings-main-navigation-expanded': open })}>
        <Div className="settings-main-navigation-header" onClick={this.handleToggleAccordion}>
          <Div className="settings-main-navigation-header-icon">
            <Icon
              name="arrow-1-right"
              width="10"
              height="10"
              className={cx('right-caret-icon', { 'rotated-nav-icon': open })}
            />
          </Div>
          <H4>{title}</H4>
        </Div>
          <Div className="settings-main-navigation-container">
            <Div
              className={cx('settings-main-navigation-content', {
                'settings-main-navigation-content--open': open,
              })}
            >
              {children}
            </Div>
          </Div>
      </Div>
    )
  }
}

export default NavAccordion



// WEBPACK FOOTER //
// ./src/scripts/components/settings/NavAccordion/index.js